<template>
  <tr>
    <td :class="{ 'tw-line-through tw-text-gray-400': isUndone }">
      {{ formatRowDate(row.created_at) }}
    </td>
    <td class="tw-text-center">
      <button
        v-if="row.import_file_url"
        class="btn btn-link tw-p-0"
        type="button"
        @click="$emit('download', row.import_file_url)"
      >
        <SvgIcon name="download" class="tw-w-4 tw-h-4" />
      </button>
    </td>
    <td :class="{ 'tw-line-through tw-text-gray-400': isUndone }">
      <div class="tw-flex tw-items-center tw-gap-2">
        <img
          v-if="row.creator && row.creator.avatar_url"
          :src="row.creator.avatar_url"
          :alt="creatorDisplayName"
          class="tw-w-6 tw-h-6 tw-rounded-full"
        />
        <span
          v-else
          class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-gray-300 tw-flex tw-items-center tw-justify-center tw-text-xs tw-text-white tw-font-bold"
        >
          {{ creatorInitials }}
        </span>
        {{ creatorDisplayName }}
      </div>
    </td>
    <td>
      <span :class="leavesImportedClass">
        {{ leavesImportedText }}
      </span>
    </td>
    <td class="tw-text-center">
      <button
        v-if="row.error_file_url"
        class="btn btn-link tw-p-0"
        type="button"
        @click="$emit('download', row.error_file_url)"
      >
        <SvgIcon name="download" class="tw-w-4 tw-h-4" />
      </button>
      <span v-else>-</span>
    </td>
    <td class="tw-text-center">
      <div v-if="isUndone" class="tw-flex tw-justify-center">
        <ExtraInfo icon="info-circle" icon-colour="tw-text-blue-500">
          <div class="tw-p-3 tw-text-sm tw-whitespace-nowrap">
            This import has already been
            <br />
            undone by
            <strong>{{ undoneByName }}</strong>
            on
            <br />
            {{ formatRowDate(row.undone_at) }}
          </div>
        </ExtraInfo>
      </div>
      <button
        v-else-if="row.can_undo"
        class="btn btn-link tw-p-0 tw-text-orange-500"
        type="button"
        @click="$emit('undo', row)"
      >
        <SvgIcon name="undo" class="tw-w-4 tw-h-4" />
      </button>
      <span v-else>-</span>
    </td>
  </tr>
</template>

<script>
import FormatDate from '@/mixins/FormatDate'
import ExtraInfo from '@/components/ExtraInfo'

export default {
  name: 'LeaveImportTimelineTableRow',

  components: { ExtraInfo },

  mixins: [FormatDate],

  props: {
    row: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isUndone() {
      return !!this.row.undone_at
    },

    creatorDisplayName() {
      return this.row.creator?.full_name ?? ''
    },

    creatorInitials() {
      const name = this.creatorDisplayName
      if (!name) return ''

      const parts = name.split(' ')
      return parts
        .map(p => p[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    },

    totalCount() {
      return this.row.successful_count + this.row.error_count
    },

    leavesImportedText() {
      if (this.row.error_count === 0) {
        return `${this.row.successful_count} of ${this.totalCount} ✓`
      }

      return `${this.row.successful_count} of ${this.totalCount} (${this.row.error_count} errors)`
    },

    leavesImportedClass() {
      if (this.isUndone) {
        return 'tw-text-gray-400 tw-line-through'
      }

      if (this.row.error_count === 0) {
        return 'tw-text-green-600'
      }

      if (this.row.successful_count === 0) {
        return 'tw-text-red-500'
      }

      return 'tw-text-orange-500'
    },

    undoneByName() {
      return this.row.undone_by?.full_name ?? ''
    },
  },

  methods: {
    formatRowDate(iso) {
      if (!iso) return ''

      return this.toMoment(iso, this.activeCompany?.timezone).format(
        this.getUserPreferredDateTimeFormat('fullMonthDateWithHourMinutes')
      )
    },
  },
}
</script>
